<script setup>;
</script>
<template>

    <Head>
        <title>Padrón de Inspectores y Verificadores</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Padrón de Inspectores y Verificadores</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-2 text-center text-md-left mb-4"><img :src="'/storage/' + seccion.imagen" alt="" loading="lazy" /></div>
                    <div class="col-lg-10 contenido-administrable text-center text-md-left" v-html="seccion.descripcion"></div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-md-8 p-0">
                        <div class="form-group">
                            <select class="form-control form__select" v-model="secretaria">
                                <option value="" :selected="secretaria == ''">Todas las Secretarías</option>
                                <option v-for="(item, i) in secretarias" :key="i" :value="item.id">{{ item.nombre }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 p-0 pl-md-2 pl-lg-2">
                        <button type="button" class="boton-principal boton-flecha">Filtrar</button>
                    </div>
                </div>
                <div class="mt-5">
                    <div class="row">
                        <div class="col-lg-4 col-md-3 col-12 mb-4" v-for="(item, index) in filterBySecretaria(datos)" :key="index">
                            <div class="item">
                                <div>
                                    <div class="col-12">
                                        <div class="row  pt-3">
                                            <div class="col-5">
                                                <img loading="lazy" width="100%" :src="'/storage/' + item.foto" alt="">
                                            </div>
                                            <div class="col-7">
                                                <div class="text">
                                                    <div class="titulo font-weight-bold">{{ item.nombre }}</div>
                                                    <div class="puesto mt-1">{{ item.puesto }}</div>
                                                    <div class="secretaria mb-3 mt-3">{{ item.secretaria.nombre }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="action p-3">
                                    <button type="button" @click="openModal(item)" class="boton-secundario boton-flecha">Mas Info</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="xl" scrollable centered hide-footer v-model="modalShow">
            <div class="content">
                <div class="row">
                    <div class="col-12 col-md-5">
                        <img loading="lazy" width="100%" :src="'/storage/' + currItem?.foto" alt="">
                    </div>
                    <div class="col-12 col-md-7 mt-3 mt-md-0">
                        <div class="secretaria mb-3">{{ currItem.secretaria?.nombre }}</div>
                        <h2 class="title mb-0 font-weight-bold ">{{ currItem?.nombre }}</h2>
                        <div class="puesto">{{ currItem?.puesto }}</div>
                        <div class="mt-3"><font-awesome-icon icon="fa-regular fa-clock" class="mr-1" /> {{ currItem?.horario }}</div>
                        <div class="direccion">
                            <div><font-awesome-icon icon="fa-regular fa-address-card" class="mr-1" /> {{ currItem?.domicilio }}</div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <font-awesome-icon icon="fa-solid fa-phone " class="mr-1" /> {{ currItem?.telefono }}
                                </div>
                                <div class="col-12 col-md-6">
                                    <font-awesome-icon icon="fa-regular fa-envelope" class="mr-1" /> {{ currItem?.correo }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="line font-weight-bold">Vigencia del cargo materia: <span class="font-weight-normal">{{ $filters.getDate(currItem?.vigencia) }}</span></div>
                                <div class="line font-weight-bold">Giro de la inspección o verificación: <span class="font-weight-normal">{{ currItem?.giro }}</span></div>
                                <div class="line font-weight-bold">Jefe inmediato: <span class="font-weight-normal">{{ currItem?.jefe_inmediato }}</span></div>
                                <div class="line font-weight-bold">Cargo del jefe inmediato: <span class="font-weight-normal">{{ currItem?.cargo }}</span></div>
                                <div class="line font-weight-bold">Fundamento jurídico de la inspección o verificación: <span class="font-weight-normal">{{ currItem?.fundamento }}</span></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faAddressCard, faClock } from '@fortawesome/free-regular-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
library.add([faEnvelope, faAddressCard, faClock, faPhone]);
export default {
    data() {
        return {
            secretaria: '',
            currItem: {},
            modalShow: false,
        }
    },
    props: {
        seccion: Object,
        datos: Object,
        groups: Object,
        secretarias: Object,
    },
    methods: {
        filterBySecretaria: function (datos) {
            return this.secretaria ?
                datos.filter((item) => item.secretaria_id.toString() === this.secretaria.toString())
                : datos;
        },
        openModal(item) {
            this.currItem = item;
            this.modalShow = true;
        },
        closeModal() {
            this.currItem = {};
            this.modalShow = false;
        }
    },
    compatConfig: { MODE: 3 }
}
</script>
<style scoped>
.bloque-general__encabezado {
    margin-top: 3.125rem;
}

.boton-principal {
    height: 3.125rem;
    padding: .0625rem 1.9375rem;
}

h2 {
    margin-top: 0;
    line-height: 1.3em;
}

.boton-secundario {
    padding: .5rem 1.25rem;
    font-size: 1rem;
}

.item {
    height: 100%;
    font-size: 1.0625rem;
    background: #FFFFFF;
    box-shadow: .125rem .125rem .625rem 0 rgba(0, 0, 0, 0.23);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.item .text {
    line-height: 20.8px;
    text-align: left;
}

.item .text .titulo {
    line-height: 1.3em;
    font-weight: bold;
}

.puesto {
    font-family: "Playfair Display", Georgia, serif;
    color: #000 !important;
}

.secretaria {
    font-family: "Playfair Display", Georgia, serif;
    font-style: italic;
    font-weight: 500;
    color: #555555;
    font-size: 1rem;
    line-height: 1.25rem;
}

.content .direccion {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #535353;
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid #535353;
}

.content .secretaria {
    font-size: 1.25rem;
}

.content h2 {
    margin: 0;
    line-height: 1.3em;
}

.item .text .datos {
    font-size: .875rem;
}

.line {
    border-bottom: .0625rem solid #dfdfdf;
    padding-top: .3125rem;
    padding-bottom: .3125rem;
}

.item .action {
    background: #F9F9F9;
    text-align: center;
}
</style>
